/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M13.75 8H14.1V8C16.2539 8 18 9.74609 18 11.9V12.1C18 14.2539 16.2539 16 14.1 16V16H13.75M10.25 8H9.9V8C7.74609 8 6 9.74609 6 11.9V12.1C6 14.2539 7.74609 16 9.9 16V16H10.25M10 12H14"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<rect
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<rect
				opacity="0.12"
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				fill="currentColor"
			/>
			<path
				d="M13.75 8H14.1V8C16.2539 8 18 9.74609 18 11.9V12.1C18 14.2539 16.2539 16 14.1 16V16H13.75M10.25 16H9.9V16C7.74609 16 6 14.2539 6 12.1V11.9C6 9.74609 7.74609 8 9.9 8V8H10.25M10 12H14M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.98005 1.79497C5.04961 1.25 6.44974 1.25 9.25 1.25H14.75C17.5503 1.25 18.9504 1.25 20.02 1.79497C20.9608 2.27433 21.7257 3.03924 22.205 3.98005C22.75 5.04961 22.75 6.44974 22.75 9.25V14.75C22.75 17.5503 22.75 18.9504 22.205 20.02C21.7257 20.9608 20.9608 21.7257 20.02 22.205C18.9504 22.75 17.5503 22.75 14.75 22.75H9.25C6.44974 22.75 5.04961 22.75 3.98005 22.205C3.03924 21.7257 2.27433 20.9608 1.79497 20.02C1.25 18.9504 1.25 17.5503 1.25 14.75V9.25C1.25 6.44974 1.25 5.04961 1.79497 3.98005C2.27433 3.03924 3.03924 2.27433 3.98005 1.79497ZM5.75 12C5.75 10.2051 7.20507 8.75 9 8.75H9.9H10.25C10.6642 8.75 11 8.41421 11 8C11 7.58579 10.6642 7.25 10.25 7.25H9.9H9C6.37665 7.25 4.25 9.37665 4.25 12C4.25 14.6234 6.37665 16.75 9 16.75H9.9H10.25C10.6642 16.75 11 16.4142 11 16C11 15.5858 10.6642 15.25 10.25 15.25H9.9H9C7.20508 15.25 5.75 13.7949 5.75 12ZM13.75 7.25C13.3358 7.25 13 7.58579 13 8C13 8.41421 13.3358 8.75 13.75 8.75H14.1H15C16.7949 8.75 18.25 10.2051 18.25 12C18.25 13.7949 16.7949 15.25 15 15.25H14.1H13.75C13.3358 15.25 13 15.5858 13 16C13 16.4142 13.3358 16.75 13.75 16.75H14.1H15C17.6234 16.75 19.75 14.6234 19.75 12C19.75 9.37665 17.6234 7.25 15 7.25H14.1H13.75ZM10 11.25C9.58579 11.25 9.25 11.5858 9.25 12C9.25 12.4142 9.58579 12.75 10 12.75H14C14.4142 12.75 14.75 12.4142 14.75 12C14.75 11.5858 14.4142 11.25 14 11.25H10Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M9.5 2L9 2V2C7.13872 2 6.20808 2 5.45492 2.24472C3.93273 2.73931 2.73931 3.93273 2.24472 5.45492C2 6.20808 2 7.13872 2 9L2 14C2 16.8003 2 18.2004 2.54497 19.27C3.02434 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V9C22 7.13872 22 6.20808 21.7553 5.45492C21.2607 3.93273 20.0673 2.73931 18.5451 2.24472C17.7919 2 16.8613 2 15 2V2L14.5 2M13.75 8H14.1V8C16.2539 8 18 9.74609 18 11.9V12.1C18 14.2539 16.2539 16 14.1 16V16H13.75M10.25 16H9.9V16C7.74609 16 6 14.2539 6 12.1V11.9C6 9.74609 7.74609 8 9.9 8V8H10.25M10 12H14"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M13.75 8H14.1V8C16.2539 8 18 9.74609 18 11.9V12.1C18 14.2539 16.2539 16 14.1 16V16H13.75M10.25 16H9.9V16C7.74609 16 6 14.2539 6 12.1V11.9C6 9.74609 7.74609 8 9.9 8V8H10.25M10 12H14M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M9.25 1.25C6.44974 1.25 5.04961 1.25 3.98005 1.79497C3.03924 2.27433 2.27433 3.03924 1.79497 3.98005C1.25 5.04961 1.25 6.44974 1.25 9.25V14.75C1.25 17.5503 1.25 18.9504 1.79497 20.02C2.27433 20.9608 3.03924 21.7257 3.98005 22.205C5.04961 22.75 6.44974 22.75 9.25 22.75H14.75C17.5503 22.75 18.9504 22.75 20.02 22.205C20.9608 21.7257 21.7257 20.9608 22.205 20.02C22.75 18.9504 22.75 17.5503 22.75 14.75V9.25C22.75 6.44974 22.75 5.04961 22.205 3.98005C21.7257 3.03924 20.9608 2.27433 20.02 1.79497C18.9504 1.25 17.5503 1.25 14.75 1.25H9.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M9 8.75C7.20507 8.75 5.75 10.2051 5.75 12C5.75 13.7949 7.20508 15.25 9 15.25H9.9H10.25C10.6642 15.25 11 15.5858 11 16C11 16.4142 10.6642 16.75 10.25 16.75H9.9H9C6.37665 16.75 4.25 14.6234 4.25 12C4.25 9.37665 6.37665 7.25 9 7.25H9.9H10.25C10.6642 7.25 11 7.58579 11 8C11 8.41421 10.6642 8.75 10.25 8.75H9.9H9ZM13 8C13 7.58579 13.3358 7.25 13.75 7.25H14.1H15C17.6234 7.25 19.75 9.37665 19.75 12C19.75 14.6234 17.6234 16.75 15 16.75H14.1H13.75C13.3358 16.75 13 16.4142 13 16C13 15.5858 13.3358 15.25 13.75 15.25H14.1H15C16.7949 15.25 18.25 13.7949 18.25 12C18.25 10.2051 16.7949 8.75 15 8.75H14.1H13.75C13.3358 8.75 13 8.41421 13 8ZM9.25 12C9.25 11.5858 9.58579 11.25 10 11.25H14C14.4142 11.25 14.75 11.5858 14.75 12C14.75 12.4142 14.4142 12.75 14 12.75H10C9.58579 12.75 9.25 12.4142 9.25 12Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
